let sonikit;
export const init = (instance) => {
  sonikit = instance;
}

export const trigger = async (patch, service, media_id, media_type) => {
  try {
    sonikit.emit('authenticationStarted', { service: service.name });

    if (service.name === 'apple-music') {
      // Show pop-up warning
      const script = document.createElement('script');
      script.src = "https://js-cdn.music.apple.com/musickit/v3/musickit.js";
      script.onerror = function() {
        console.log("Error loading apple music" + script.src);
      };
      document.head.appendChild(script);

      document.addEventListener('musickitloaded', async function() {
        console.log('mkloaded')
        await MusicKit.configure({
          developerToken: sonikit.apple_token,
          app: {
            name: 'Sonikit',
            icon: 'https://www.sonikit.com/sonikit-logo.jpg',
            build: '1'
          }
        })

        const apple_music = MusicKit.getInstance();
        apple_music.authorize().then(async (access_token) => {
          const fan = await getUser('apple-music', null, access_token);
          const fan_id = fan.id ? fan.id : fan._id;
          await sonikit.setFan(fan_id);
          sonikit.handleCallback(patch.id, service.id);
        }).catch(error => {
          console.log(error)
        })
      });
    } else {
      const source = sonikit.page_id ? 'page' : 'embed';
      const redirect_uri = window.location.href.split(/[?#]/)[0];
      
      const body = { 
        service_id: service.id, 
        source,
        redirect_uri,
        location: sonikit.location 
      }
      if (media_id) body.media_id = media_id;
      if (media_type) body.media_type = media_type;
      
      const response = await fetch(`${sonikit.base_url}/auth-sessions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${sonikit.apiKey}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })

      if (!response.ok) return console.log('Invalid auth');
      const session = await response.json();

      window.location.href = `${sonikit.base_url}/authenticate?session=${session.id}`;
    }
  } catch (error) {
    console.log(error)
  }
}

export const getUser = async (service_name, fan_id, access_token) => {
  try {
    const body = {
      fan_id,
      service_name, 
      access_token,
      location: sonikit.location
    }
    
    const res = await fetch(`${sonikit.base_url}/get-user`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${sonikit.project._id}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })

    if (!res.ok) {
      clearSessions()
      return false
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.log(error)
    clearSessions()
    return { error: 'Get user error.' }
  }
}

export const clearSessions = (player) => {
  localStorage.removeItem('sonikit-store');
  
  if (window.MusicKit) {
    const apple_music = MusicKit.getInstance();
    apple_music.unauthorize();
  }

  if (player) {
    player.reset();
  }
}